module.exports = __webpack_public_path__ + "img/g-matrix.cf182829.png";